"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Image_1 = require("ContentTokens/DataModels/Image");
var EventUtils_1 = require("Utils/EventUtils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var AltTextPanel_1 = require("../AltTextPanel/AltTextPanel");
var getOpacity = function (percent) {
    if (percent != null) {
        return 0.25 + percent * 0.0075;
    }
    else {
        return 1;
    }
};
var generateTranslateString = function (percent) {
    return "translate(".concat(percent.x, "%, ").concat(percent.y, "%)");
};
var fullInstructionMessage = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(icons_1.Move, null),
        react_1.default.createElement("span", { className: "text-context-label" }, "Drag to reposition")));
};
var smallInstructionMessage = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(icons_1.Move, null),
        react_1.default.createElement("span", { className: "text-context-label" }, "reposition")));
};
var tinyInstructionMessage = function () {
    return react_1.default.createElement(icons_1.Move, null);
};
var Image = (function (_super) {
    __extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this.isRepositioning = false;
        _this.startingClickPosition = null;
        _this.isShowingInstructions = false;
        _this.repositioningLimit = null;
        _this.placeholderImage = "Assets/icons/large/image-placeholder.svg";
        _this.renderInstructions = function () {
            var hideInstructions = !_this.isShowingInstructions || !_this.props.isRepositioningMode;
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)("image-widget__reposition-instruction center", {
                    "image-widget__reposition-instruction--hide": hideInstructions,
                }), contentEditable: false }, _this.renderInstructionsMessage()));
        };
        _this.renderInstructionsMessage = function () {
            if (!_this.containerRef.current) {
                return fullInstructionMessage();
            }
            var containerRect = _this.containerRef.current.getBoundingClientRect();
            if (containerRect.width < 140) {
                return tinyInstructionMessage();
            }
            else if (containerRect.width < 220) {
                return smallInstructionMessage();
            }
            else {
                return fullInstructionMessage();
            }
        };
        _this.startRepositioning = function (event) {
            if (!_this.props.isRepositioningMode) {
                return;
            }
            if ((0, EventUtils_1.isPrimaryButton)(event)) {
                _this.hideInstructions();
                _this.isRepositioning = true;
                _this.startingClickPosition = {
                    x: event.pageX,
                    y: event.pageY,
                };
                _this.calculateRepositioningLimit();
                window.addEventListener("mousemove", _this.reposition);
                window.addEventListener("mouseup", _this.stopRepositioning);
                event.preventDefault();
                event.stopPropagation();
            }
        };
        _this.reposition = function (event) {
            if (!_this.startingClickPosition) {
                return;
            }
            var percentPerPixel = 0.1;
            var xChange = (_this.startingClickPosition.x - event.pageX) * percentPerPixel;
            var yChange = (_this.startingClickPosition.y - event.pageY) * percentPerPixel;
            var baseX = _this.props.translationX;
            var baseY = _this.props.translationY;
            _this.repositioningTranslation = _this.limitRepositioning({
                x: baseX - xChange,
                y: baseY - yChange,
            });
        };
        _this.stopRepositioning = function () {
            _this.isRepositioning = false;
            _this.props.finishReposition(_this.repositioningTranslation);
            window.removeEventListener("mouseup", _this.stopRepositioning);
            window.removeEventListener("mousemove", _this.reposition);
        };
        _this.maybePreventDragging = function (event) {
            if (_this.isRepositioning) {
                event.preventDefault();
            }
        };
        _this.limitRepositioning = function (curr) {
            if (!_this.repositioningLimit) {
                throw new Error("Attempting to limit repositioning without a repositioning limit");
            }
            var xLimit = _this.repositioningLimit.x;
            var yLimit = _this.repositioningLimit.y;
            var minimumBackwards = 50 * (_this.props.scale - 1);
            return {
                x: Math.max(-xLimit, Math.min(minimumBackwards, curr.x)),
                y: Math.max(-yLimit, Math.min(minimumBackwards, curr.y)),
            };
        };
        _this.calculateRepositioningLimit = function () {
            if (!_this.containerRef.current || !_this.imageRef.current) {
                return;
            }
            var containerRect = _this.containerRef.current.getBoundingClientRect();
            var imageRect = _this.imageRef.current.getBoundingClientRect();
            var scale = _this.props.scale;
            var naturalImageWidth = imageRect.width / scale;
            var naturalImageHeight = imageRect.height / scale;
            var widthOverflowPercentage = ((naturalImageWidth - containerRect.width) * 100) / naturalImageWidth;
            var heightOverflowPercentage = ((naturalImageHeight - containerRect.height) * 100) / naturalImageHeight;
            var extraOverflow = 50 * (scale - 1);
            _this.repositioningLimit = {
                x: widthOverflowPercentage + extraOverflow,
                y: heightOverflowPercentage + extraOverflow,
            };
        };
        _this.showInstructions = function () {
            _this.isShowingInstructions = true;
            setTimeout(function () {
                _this.hideInstructions();
            }, 2000);
        };
        _this.hideInstructions = function () {
            _this.isShowingInstructions = false;
        };
        _this.keepCentered = function (previousWidth) {
            if (typeof _this.props.width !== "number") {
                return;
            }
            var widthChange = previousWidth - _this.props.width;
            var translateAmount = widthChange / 2;
            var newTranslation = {
                x: _this.props.translationX - translateAmount,
                y: _this.props.translationY,
            };
            _this.props.finishReposition(_this.limitRepositioning(newTranslation), true);
        };
        _this.repositioningTranslation = {
            x: _this.props.translationX,
            y: _this.props.translationY,
        };
        _this.containerRef = react_1.default.createRef();
        _this.imageRef = react_1.default.createRef();
        return _this;
    }
    Image.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isRepositioningMode && !prevProps.isRepositioningMode) {
            this.showInstructions();
        }
        if (this.props.frame !== prevProps.frame) {
            this.calculateRepositioningLimit();
            if (this.props.frame === Image_1.ImageFrame.Circle && typeof prevProps.width === "number") {
                this.keepCentered(prevProps.width);
            }
            else {
                this.props.finishReposition(this.limitRepositioning({ x: 0, y: 0 }), true);
            }
        }
        if (prevProps.scale !== this.props.scale) {
            this.calculateRepositioningLimit();
            this.props.finishReposition(this.limitRepositioning({ x: this.props.translationX, y: this.props.translationY }));
        }
    };
    Image.prototype.render = function () {
        var showImagePlaceholder = !(this.props.src || this.props.uploadPercent != undefined);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)("image-widget__frame", {
                    "image-widget__frame--circle": this.props.frame === Image_1.ImageFrame.Circle,
                    "image-widget__frame--repositioning": this.props.isRepositioningMode,
                    "image-widget__frame--placeholder": showImagePlaceholder,
                    center: this.props.frame === Image_1.ImageFrame.None,
                }), ref: this.containerRef },
                !showImagePlaceholder && (react_1.default.createElement("img", { src: this.props.src, onLoad: this.props.handleImageLoad, alt: this.props.alt || AltTextPanel_1.AltTextAttributeState.Empty, role: this.props.role || AltTextPanel_1.RoleAttributeState.Empty, className: "image-widget__container", style: __assign({ opacity: getOpacity(this.props.uploadPercent) }, this.imageStyle), onMouseDown: this.startRepositioning, onDragStart: this.maybePreventDragging, ref: this.imageRef })),
                showImagePlaceholder && (react_1.default.createElement("div", { className: "image-widget__placeholder", onMouseDown: this.startRepositioning, onDragStart: this.maybePreventDragging, ref: this.imageRef },
                    react_1.default.createElement(icons_1.Image, { size: icons_1.IconSize.Large }),
                    react_1.default.createElement("div", { className: "image-widget__placeholder-text" }, " Select an image by selecting swap from the menu "))),
                this.props.frame === Image_1.ImageFrame.Circle && (react_1.default.createElement("img", { src: this.props.src, className: (0, classnames_1.default)("image-widget__ghost", { "image-widget__ghost--hiding": !this.isRepositioning }), style: this.imageStyle })),
                this.renderInstructions())));
    };
    Object.defineProperty(Image.prototype, "imageStyle", {
        get: function () {
            var _a = this.props, aspectRatio = _a.aspectRatio, frame = _a.frame, scale = _a.scale;
            var style = {
                transform: "".concat(this.translateStyle, " scale(").concat(scale, ")"),
            };
            if (frame === Image_1.ImageFrame.Circle && aspectRatio > 1) {
                var fillHeightPercent = aspectRatio * 100;
                style.minWidth = "".concat(fillHeightPercent, "%");
            }
            return style;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Image.prototype, "translateStyle", {
        get: function () {
            if (!this.isRepositioning) {
                return generateTranslateString({ x: this.props.translationX, y: this.props.translationY });
            }
            else {
                return generateTranslateString(this.repositioningTranslation);
            }
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Image.prototype, "isRepositioning", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Image.prototype, "startingClickPosition", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_b = typeof Image_1.ICoordinate !== "undefined" && Image_1.ICoordinate) === "function" ? _b : Object)
    ], Image.prototype, "repositioningTranslation", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Image.prototype, "isShowingInstructions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Image.prototype, "startRepositioning", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Image.prototype, "reposition", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Image.prototype, "stopRepositioning", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], Image.prototype, "translateStyle", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Image.prototype, "showInstructions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Image.prototype, "hideInstructions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Image.prototype, "keepCentered", void 0);
    Image = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Image);
    return Image;
}(react_1.default.Component));
exports.default = Image;
